import { render, staticRenderFns } from "./CreateMortgage.vue?vue&type=template&id=e4058f3c"
import script from "./CreateMortgage.vue?vue&type=script&lang=ts"
export * from "./CreateMortgage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports